import React from "react"
import {
  TYPE_NONE,
  TYPE_HIDDEN,
  TYPE_RADIO,
  TYPE_UPLOAD,
  TYPE_CHECKBOX,
  TYPE_DATETIME
} from "@components/Form"
import { W0, W1 } from "@components"
import { Disclaimer } from "@components/Text"

const LABEL_TYPE = "Type"
const LABEL_DATE = "Report Date"
const LABEL_SEND_NO = "Do not send"
const LABEL_SEND_YES = "Schedule for"
const LABEL_DATETIME = "Date & Time"
const LABEL_NOTIFICATIONS = "Investor Notifications"
const LABEL_IS_PUBLIC_FILE = "Include the report link in the investor notification"
const LABEL_TYPE_PLACEHOLDER = "Select document type"
const LABEL_NOTIFICATIONS_DISCLAIMER = "Notifications are disabled for project files."


const getCreateInputs = (
  projectId,
  typeOptions,
  isSent,
  isPublic,
  hasScheduleOption,
  customTemplateProps = []
) => {
  const commonInputProps = {
     size: "medium",
   }

  const shouldSchedule = !isSent

  const scheduledAtProps = !shouldSchedule
    ? { type: TYPE_NONE }
    : {
        type: TYPE_DATETIME,
        label: LABEL_DATETIME,
        required: true,
        itemProps: {
          style: { marginBottom: W1 },
        },
        inputProps: {
          minuteStep: 15,
          showNow: true,
          ...commonInputProps,
        }
      }

  const publicProps = !shouldSchedule
    ? { type: TYPE_NONE }
    : {
        type: TYPE_CHECKBOX,
        initialValue: true,
        itemProps: {
          style: { marginBottom: W0 },
        },
        inputProps: {
          label: LABEL_IS_PUBLIC_FILE,
        }
      }

  return [
    {
      name: "projectId",
      type: TYPE_HIDDEN,
      initialValue: projectId,
    },
    {
      name: "documentType",
      label: LABEL_TYPE,
      options: typeOptions,
      required: true,
      placeholder: LABEL_TYPE_PLACEHOLDER,
      hasAutoComplete: true,
    },
    {
      name: "name",
      placeholder: "",
    },
    {
      name: "date",
      label: LABEL_DATE,
      inputProps: {
        style: { width: 127 }
      },
    },
    {
      name: "isSent",
      type: TYPE_RADIO,
      label: LABEL_NOTIFICATIONS,
      initialValue: true,
      options: [
        {
          value: true,
          label: LABEL_SEND_NO,
          disabled: !hasScheduleOption,
        },
        {
          value: false,
          label: LABEL_SEND_YES,
          disabled: !hasScheduleOption,
        },
      ],
      itemProps: {
        style: { marginBottom: W1 },
        extra: hasScheduleOption
          ? undefined
          : <Disclaimer text={LABEL_NOTIFICATIONS_DISCLAIMER} style={{ marginTop: W0 }} />
      },
    },
    {
      name: "scheduledAt",
      label: "",
      ...scheduledAtProps,
    },
    ...customTemplateProps,
    {
      name: "isPublicFile",
      label: "",
      ...publicProps,
    },
    {
      name: "fileUrl",
      type: TYPE_UPLOAD,
      label: "",
      inputProps: {
        isPublic,
        onChange: (event, _form) => {
          const { name } = event.file
          _form.setFieldValue("fileSourceFileName", name)
        }
      }
    },
    {
      name: "fileSourceFileName",
      type: TYPE_HIDDEN,
    },
  ]
}

export default getCreateInputs
